var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTqlWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 35,
    viewBox: "0 0 116 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 35,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2433,
    transform: "translate(-32 -19)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -19,
    width: 1920,
    height: 2433,
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -19,
    width: 1920,
    height: 72,
    fill: "#0093D0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.91199 9.27638H0V4.52429H22.8041V9.27638H13.8921V33.7026H8.91199V9.27638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6147 34.5757L45.2434 31.4501C42.8743 33.1604 39.983 34.2009 36.6924 34.2009C28.0607 34.2009 22.04 27.4077 22.04 19.1952V19.1114C22.04 10.8989 28.1413 4.02197 36.773 4.02197C45.4047 4.02197 51.4254 10.8152 51.4254 19.0277V19.1114C51.4254 22.4044 50.381 25.53 48.5763 28.0734L51.7863 30.9079L48.6147 34.5757ZM41.6303 28.1173L36.773 23.8237L39.9446 20.0722L44.8825 24.7406C45.7656 23.1579 46.2456 21.2802 46.2456 19.1952V19.1114C46.2456 13.4424 42.2715 8.73021 36.6924 8.73021C31.1094 8.73021 27.216 13.3587 27.216 19.0277V19.1114C27.216 24.7805 31.1901 29.4488 36.773 29.4488C38.6199 29.4488 40.2672 28.9505 41.6303 28.1173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8026 4.52429H60.7405V29.0342H75.5157V33.7026H55.8026V4.52429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.62 18.362C105.754 15.9222 109.854 11.6883 112.208 6.44588C108.261 1.41872 101.756 -1.12078 95.2673 0.473879C86.8122 2.55092 81.3637 10.9069 82.4234 19.6576C88.805 21.5473 95.275 20.9413 100.62 18.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.545 13.4743C115.18 11.8717 114.612 10.3687 113.878 8.99731C112.895 14.5826 110.427 19.5739 106.848 23.4011C102.336 28.2728 96.0506 31.2707 89.189 31.6136C93.0287 34.5318 98.0319 35.7517 103.024 34.5278C112.081 32.2993 117.684 22.8748 115.545 13.4743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0505 23.3645C79.9929 23.2651 79.9353 23.1697 79.8777 23.0742C79.9353 23.1697 79.9929 23.2691 80.0505 23.3645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5497 24.1899C80.4997 24.1104 80.4498 24.0308 80.4037 23.9513C80.4498 24.0308 80.4997 24.1104 80.5497 24.1899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68 20.9773C109.927 16.4405 113.932 8.89773 114.132 0.374268H114.128C113.698 8.79806 109.463 16.1694 103.043 20.459C96.6572 24.7805 88.087 26.0124 79.7778 22.9148C79.8085 22.9666 79.8431 23.0224 79.8738 23.0743C79.9314 23.1699 79.989 23.2696 80.0466 23.3653C80.1618 23.5606 80.2808 23.752 80.3999 23.9473C80.4498 24.0271 80.4959 24.1068 80.5458 24.1865C80.588 24.2583 80.6302 24.3261 80.6725 24.3978H80.6763C89.0085 27.1048 97.4674 25.546 103.68 20.9773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_4",
    x: -56,
    y: -56,
    width: 1968,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 2433,
    fill: "white",
    transform: "translate(-32 -19)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTqlWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TQL White.973af01c6006440a006fc574a970c164.svg";